import $ from 'jquery';
import FileList, {initFileList} from '../components/FileList';
import ReactDOMServer from 'react-dom/server';

import appUi from '../helpers/ui';

import { KEY_ACCESS_TOKEN } from '../modals/login';

import iconAdministratorMale from '../administrator-male.png';

export default {
    VERSION: '1.27.5',
    CHATBOX: null,
    CONN: null,
    FCM_TOKEN: null,

    JsQRScanner: null,
    jbScanner: null,

    wsBaseUrl: null, // To be set by the main app
    apiBaseUrl: null, // To be set by the main app
    utilBaseUrl: null, // To be set by the main app
    // apiBaseUrl: 'http://push-api.localhost/v1',
    // apiBaseUrl: 'https://push-api.onwork.dev/v1',

    currentGeoLocation: null,

    _ajax_send(_postdata, _finishcallback, _msg, _requesturl) {
        let _ov_msg = _msg || 'Menyimpan...';
        let _reqURL = _requesturl;
        let beforeSendCallback = null;
        let alwaysCallback = null;
        let okCallback = null;
        let progressCallback = null;
        let errorCallback = function(response) {
            appUi.uiAlert("Error returned: "+response.message, null, 'Failed', 'error');
        };

        let useLoader = true;
        let skipToken = false;
        let ajaxType = "POST"; // Default is POST
        let ajaxXhr = null;

        if (typeof(_finishcallback)=='function') {
            okCallback = _finishcallback;

        } else if (typeof(_finishcallback)=='object') {
            if ('beforeSend' in _finishcallback)
                beforeSendCallback = _finishcallback.beforeSend;
            if ('success' in _finishcallback)
                okCallback = _finishcallback.success;
            if ('error' in _finishcallback)
                errorCallback = _finishcallback.error;
            if ('always' in _finishcallback)
                alwaysCallback = _finishcallback.always;
            if ('uploadProgress' in _finishcallback)
                progressCallback = _finishcallback.uploadProgress;

            //-- Fetch parameters
            if ('useLoader' in _finishcallback) useLoader = _finishcallback.useLoader;
            if ('skipToken' in _finishcallback) skipToken = _finishcallback.skipToken;
            if ('type' in _finishcallback) ajaxType = _finishcallback.type;
            if ('xhr' in _finishcallback) ajaxXhr = _finishcallback.xhr;
        }

        let headers = {'Accept': 'application/json'};

        var accessToken = localStorage.getItem(KEY_ACCESS_TOKEN);
        if (!skipToken && accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        let ajaxSetting = {
            type: ajaxType,
            url: _reqURL,
            data: _postdata,
            dataType: 'json',
            // contentType: "application/json; charset=utf-8",
            headers: headers,
            beforeSend: (jqXhr) => {
                if (typeof(beforeSendCallback)=='function') {
                    if (beforeSendCallback(jqXhr) === false) return false;
                }

                if (useLoader) {
                    // appUi.show_overlay(_ov_msg);
                }
            },
            success: (response) => {
                if (response.status != 'ok') {
                    if (typeof(errorCallback)=='function')
                        errorCallback(response);
                } else {
                    if (typeof(okCallback)=='function')
                        okCallback(response);
                }
            },
            error(jqXHR) {
                //self.handleAjaxError();

                //-- Try to parse response as JSON
                let respData = null;
                try {
                    respData = JSON.parse(jqXHR.responseText);
                    if (respData.status == 'invalid-session') {
                        localStorage.removeItem(KEY_ACCESS_TOKEN);
                    }

                } catch (e) {
                    respData = {
                        status: jqXHR.status,
                        message: "Request failed.",
                        xhr: jqXHR,
                        rawdata: jqXHR.responseText
                    };
                }

                if (typeof(errorCallback)=='function') {
                    errorCallback(respData);
                } else {
                    appUi.uiAlert("Request error: "+jqXHR.status + " " + jqXHR.statusText, null, 'Failed', 'error');
                }
            }
        };

        if (typeof(_finishcallback)=='object') {
            if ('processData' in _finishcallback) ajaxSetting.processData = _finishcallback.processData;
            if ('contentType' in _finishcallback) ajaxSetting.contentType = _finishcallback.contentType;
        }

        if (_postdata instanceof FormData) {
            //-- Setup for uploading...
            ajaxSetting.processData = false;
            ajaxSetting.contentType = false;
            ajaxSetting.cache = false;
        }

        if (typeof(progressCallback) == 'function') {
            ajaxSetting.xhr = () => {
                var xhr = (typeof(ajaxXhr) == 'function' ? ajaxXhr() : new window.XMLHttpRequest());
                xhr.upload.addEventListener("progress", (evt) => {
                    if (evt.lengthComputable) {
                        var percentComplete = evt.loaded / evt.total;
                        percentComplete = parseInt((percentComplete * 10000)) / 100;
                        progressCallback(evt, evt.loaded, evt.total, percentComplete);
                    }
                }, false);

                return xhr;
            }
        } else if (typeof(ajaxXhr) == 'function') {
            ajaxSetting.xhr = ajaxXhr;
        }

        $.ajax(ajaxSetting).always(function() {
            if (typeof(alwaysCallback)=='function')
                alwaysCallback();

            if (useLoader) {
                // appUi.hide_overlay();
            }
        });
    },

    _ui_forminput_setenabled: function (formElmt, _enabled) {
        if (_enabled) {
            $('input:not(.always-disabled), textarea:not(.always-disabled), button:not(.always-disabled), select:not(.always-disabled)', formElmt)
                .removeAttr('disabled');
            $('input, textarea, button, select', formElmt).removeClass('always-disabled');
        } else {
            $('input:disabled, textarea:disabled, button:disabled, select:disabled', formElmt).addClass('always-disabled');
            $('input, textarea, button, select', formElmt).attr('disabled','disabled');
        }
    },

    /**
     * Init AjaxForm. Require jquery.form.min.js (http://malsup.com/jquery/form/)
     *
     * @param elmtForm Target form to be assigned
     * @param opts The options
     */
    _web_ajaxform (elmtForm, opts) {
        let defaultOpts = {
            url: null,
            dataType: 'json',
            clearForm: true,
            progressElmt: '#web_upload_progress',
            _progressBar: null,
            progressValueClass: '.progress_val',
            errorElmt: '#web_upload_error',
            error: null,
            errorPrefix: '<div><i class="fa fa-times"></i> ',
            errorPostfix: '</div>',
            beforeSend: null,
            uploadProgress: function( percentage, progressLabel ){ },
            success: null,
            complete: null,
            processingLabel: 'Uploading...'
        };
        let callParam = $.extend( defaultOpts, opts );

        //-- Find progressbar element
        if (callParam._progressBar === null) callParam._progressBar = $(callParam.progressElmt).find('.progress-bar').first();
        callParam._updateProgress = ( percentage, progressLabel ) => {
            $(callParam._progressBar).width(percentage+'%');
            $(callParam._progressBar).html(percentage+"%");
            $(callParam.progressElmt).find(callParam.progressValueClass).text(percentage);

            callParam.uploadProgress.call( elmtForm, percentage, progressLabel );
        };

        callParam._updateError = ( respData ) => {
            if (callParam.errorElmt) {
                $(callParam.errorElmt).html(callParam.errorPrefix + respData.message + callParam.errorPostfix).show();
            }

            if (typeof(callParam.error) == 'function') callParam.error.call( respData );
        };

        let formData = new FormData(elmtForm);
        let ajaxParam = {
            useLoader: false,
            url: callParam.url,
            dataType: callParam.dataType,
            clearForm: callParam.clearForm,
            type: 'POST',
            beforeSend: () =>
            {
                this._ui_forminput_setenabled( elmtForm, false );

                //-- Clear everything
                callParam._updateProgress( 0, 'Initializing...' );
                $(callParam.progressElmt).show();
                $(callParam.errorElmt).empty().hide();

                if (typeof(callParam.beforeSend) == 'function') callParam.beforeSend.call( elmtForm );
            },
            uploadProgress: (event, position, total, percentComplete) =>
            {
                callParam._updateProgress( percentComplete, callParam.processingLabel);
            },
            success: (response) =>
            {
                if (('errors' in response) && (response.errors.length > 0)) {
                    response.message = response.errors[0].message;
                    callParam._updateError( response );
                    
                } else {
                    if (typeof(callParam.success) == 'function') callParam.success.call( elmtForm, response );
                }
            },
            always: () =>
            {
                callParam._updateProgress( 100, 'Finished' );
                $(callParam.progressElmt).hide();

                this._ui_forminput_setenabled( elmtForm, true );

                if (callParam.clearForm) {
                    elmtForm.reset();
                }

                if (typeof(callParam.complete) == 'function') callParam.complete.call( elmtForm );
            },
            error: ( respData ) =>
            {
                callParam._updateError( respData );
            }
        };

        return this._ajax_send(formData, ajaxParam, callParam.processingLabel, callParam.url);
    },

    utf8_to_b64(str) {
        var encoder = new TextEncoder('utf-8');
        var encodedContent = btoa(String.fromCharCode.apply(null, encoder.encode(str)));
        return encodedContent;
    },

    b64_to_utf8(str) {
        var decoder = new TextDecoder('utf-8');
        var decodedContent = decoder.decode(new Uint8Array(atob(str).split('').map(function(c) {
            return c.charCodeAt(0);
        })));
        return decodedContent;
    },

    getCurrentTime() {
        var today = new Date();
        var valHours = today.getHours();
        var valMinutes = today.getMinutes();

        return (valHours < 10 ? '0' + valHours : valHours)
            + ":" + (valMinutes < 10 ? '0' + valMinutes : valMinutes);
    },

    addBubble(message, sender) {
        var elmtLastConversation = $('.media:last-child', this.CHATBOX).first();
        var conversationElmt = null;

        var _sender = sender || 'system';

        if ($(elmtLastConversation).hasClass('opposite') && ($(elmtLastConversation).data('sender') == _sender)) {
            conversationElmt = $(elmtLastConversation).find('.media-body .chats');
            
        } else {
            var today = new Date();
            var strTime = this.getCurrentTime();

            var publicUrl = process.env.PUBLIC_URL || '/';
            // console.log('publicUrl', publicUrl);

            var parentMedia = $('<div class="media media-chat opposite" />').appendTo(this.CHATBOX);
            $('<img class="avatar" alt="Avatar">')
                .attr('src', iconAdministratorMale)
                .appendTo( parentMedia );
            var conversationParentElmt = $('<div class="media-body" />').appendTo( parentMedia );

            $(parentMedia).attr('data-sender', _sender);
            var senderTag = $('<div />').text(_sender).css({
                'font-size': '10pt',
                'color': '##333333'
            }).appendTo( conversationParentElmt );
            
            conversationElmt = $('<div class="chats"></div>').appendTo( conversationParentElmt );
            $('<p class="meta"><time datetime="'+today.getTime()+'">'+strTime+'</time></p>').appendTo( conversationParentElmt );
        }
    
        if (typeof(message) == 'object') {
            if ('dom' in message) {
                $('<p />').append(message.dom).appendTo( conversationElmt );
            } else if ('html' in message) {
                $('<p />').html(message.html).appendTo( conversationElmt );
            }
            
        } else {
            var htmlTag = (message + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
            $('<p />').html(htmlTag).appendTo( conversationElmt );
        }
    },

    alertMessage(message) {
        $('<div class="media media-meta-day text-danger" />').text(message).appendTo(this.CHATBOX);
    },

    noticeMessage(message) {
        $('<div class="media media-meta-day" />').text(message).appendTo(this.CHATBOX);
    },

    copyableMessage(text, message) {
        var newElmt = $('<div class="list_container"><i class="fa fa-circle-notch fa-spin"></i> Loading...</div>');

        if (this.CHATBOX) {
            this.addBubble({dom: newElmt});
            
            //-- Create copyable input
            var inputElmt = $('<textarea class="form-control" readonly style="width: 350px; height: 100px; font-size: 12px; font-family: monospace;" />').val(text);
            $(newElmt).html('<div class="bubble_copyable"><span class="copyable_message"></span>: <a href="javascript:void(0);" class="btn btn-sm btn-secondary btn_copytoken" data-token="'
                +text+'"><i class="fa fa-copy"></i> Copy</a></div>').append(inputElmt);
            $(newElmt).find('.btn_copytoken').on('click', (e) => {
                e.preventDefault();
                navigator.clipboard.writeText(text).then(() => {
                    appUi.uiToast("Copied to clipboard!", 'success');
                }).catch(err => {
                    appUi.uiToast("Failed to copy: "+err, 'error');
                });
            });

            $(newElmt).find('.copyable_message').text(message);
            $(this.CHATBOX).prop({ scrollTop: $(this.CHATBOX).prop('scrollHeight') });
        }
    },

    logout(callback) {
        this._ajax_send(null, {
            type: 'POST',
            success: (response) => {
                callback(response);
            },
            error: (response) => {
                callback(response);
            }
        }, 'Logging out...', this.apiBaseUrl + '/auth/logout');
    },

    listFiles(page) {
        var newElmt = $('<div class="list_container"><i class="fa fa-circle-notch fa-spin"></i> Fetching files...</div>');
        this._ajax_send(null, {
            type: 'GET',
            beforeSend: () => {
                this.addBubble({dom: newElmt});
            },
            success: (response) => {
                $(newElmt).html('');

                // const htmlString = ReactDOMServer.renderToString(<FileList files={response.data} />);
                const htmlString = ReactDOMServer.renderToStaticMarkup(<FileList files={response.data} page={page}/>);
                $(newElmt).append(htmlString);
                initFileList(newElmt);
                
                // var newElmt = $('<div />').html(htmlString);
                // this.addBubble({dom: newElmt});
                // initFileList(newElmt);

                //-- Archived
                // var files = response.data;
                // for (var i=0; i<files.length; i++) {
                //     var fileSize = files[i].file_size;
                //     var tmpHtml = '<div style="margin-bottom: 5px; color: #AAA; padding: 3px;"><small><i class="fa fa-calendar"></i> '+
                //         files[i].created_at+' | Size '+fileSize+'</small></div>';

                //     if (files[i].url_preview) {
                //         tmpHtml += '<img src="'+files[i].url_preview+'" style="width: 100px; border-radius: 3px;" alt="preview"/>';
                //     }

                //     tmpHtml += '<a href="'+files[i].url+'" target="_blank" style="margin-left: 10px; display: inline-block; text-overflow: ellipsis; '+
                //         'text-wrap: nowrap; max-width: 250px; overflow: hidden; vertical-align: top;"><i class="fa fa-file"></i> '+files[i].file_name+'</a><br />';

                //     tmpHtml += '<span class="text-muted" style="display: inline-block;">'+files[i].file_title	+'</span>';
                //     $(newElmt).append(tmpHtml);
                // }

                $(this.CHATBOX).prop({ scrollTop: $(this.CHATBOX).prop('scrollHeight') });
            },
            error: (response) => {
                $(newElmt).html('<div class="text-danger"><i class="fa fa-times"></i> Error: '+response.message+'</div>');
            }
        }, 'Fetching files...', this.apiBaseUrl + '/files?page='+(page || 1));
    },

    listAudio() {
        var newElmt = $('<div class="list_container"><i class="fa fa-circle-notch fa-spin"></i> Fetching audio list...</div>');
        this._ajax_send(null, {
            type: 'GET',
            beforeSend: () => {
                this.addBubble({dom: newElmt});
            },
            success: (response) => {
                $(newElmt).html('');

                // const htmlString = ReactDOMServer.renderToString(<FileList files={response.data} />);
                // const htmlString = ReactDOMServer.renderToStaticMarkup(<FileList files={response.data} />);

                // var newElmt = $('<div />').html(htmlString);
                // this.addBubble({dom: newElmt});
                // initFileList(newElmt);

                var files = response.data;
                for (var i=0; i<files.length; i++) {
                    var tmpHtml = $('<div class="p-1 mb-1" style="border: solid 1px #AAA; border-radius: 5px; min-width: 300px;">'+
                        '<a href="#" class="btn btn-sm btn-secondary btn_playaudio" data-uuid="'+
                        files[i].uuid+'"><i class="fa fa-play fa-fw"></i> Play</a> '+files[i].audio_title+
                        '<div class="audio_filename mt-2" style="font-size:8pt;"></div><div class="audio_container mt-1"></div></div>');

                    $(tmpHtml).attr('data-uuid', files[i].uuid);
                    $(tmpHtml).find('.audio_filename').text(files[i].audio_filename);

                    $(tmpHtml).find('.btn_playaudio').on('click', (e) => {
                        e.preventDefault();
                        var elParent = $(e.target).closest('div');
                        var uuid = $(elParent).data('uuid');
                        this.fetchAudio(uuid, elParent);

                        $(elParent).find('.btn_playaudio').hide();
                    });
                    // this.addBubble({html: tmpHtml});
                    $(newElmt).append(tmpHtml);
                }

                $(this.CHATBOX).prop({ scrollTop: $(this.CHATBOX).prop('scrollHeight') });
            },
            error: (response) => {
                $(newElmt).html('<div class="text-danger"><i class="fa fa-times"></i> Error: '+response.message+'</div>');
            }
        }, 'Fetching audio...', this.utilBaseUrl+'/?p=api&act=list_audio');
    },

    fetchAudio(uuid, elParent) {
        var elAudioContainer = $(elParent).find('.audio_container').first();
        this._ajax_send(null, {
            type: 'GET',
            beforeSend: () => {
                $(elAudioContainer).html('<div class="text-center"><i class="fa fa-circle-notch fa-spin"></i> Loading...</div>');
            },
            success: (response) => {
                var tmpHtml = $('<audio controls style="width: 100%;"><source src="'+response.data.url+'" type="audio/mpeg"></audio>');
                $(elAudioContainer).html(tmpHtml);
            },
            error: (response) => {
                $(elAudioContainer).html('<div class="text-danger"><i class="fa fa-times"></i> Error: '+response.message+'</div>');
            }
        }, 'Fetching audio...', this.utilBaseUrl+'/?p=api&act=detail_audio&uuid='+uuid);
    },

    generateUuid(callback) {
        var newElmt = $('<div class="list_container"><i class="fa fa-circle-notch fa-spin"></i> Generating UUID...</div>');
        this._ajax_send(null, {
            type: 'GET',
            beforeSend: () => {
                this.addBubble({dom: newElmt});
            },
            success: (response) => {
                //-- Create copyable input
                var inputElmt = $('<input type="text" class="form-control" readonly style="width: 350px;" />').val(response.data.uuid);
                $(newElmt).html('<div>Your generated UUID: <a href="javascript:void(0);" class="btn btn-sm btn-secondary btn_copyuuid" data-uuid="'
                    +response.data.uuid+'"><i class="fa fa-copy"></i> Copy</a></div>').append(inputElmt);
                $(newElmt).find('.btn_copyuuid').on('click', (e) => {
                    e.preventDefault();
                    navigator.clipboard.writeText(response.data.uuid).then(() => {
                        appUi.uiToast("UUID copied to clipboard!", 'success');
                    }).catch(err => {
                        appUi.uiToast("Failed to copy UUID: "+err, 'error');
                    });
                });
                $(this.CHATBOX).prop({ scrollTop: $(this.CHATBOX).prop('scrollHeight') });

                callback(response.data.uuid);
            },
            error: (response) => {
                $(newElmt).html('<div class="text-danger"><i class="fa fa-times"></i> Error: '+response.message+'</div>');
            }
        }, 'Generating UUID...', this.apiBaseUrl + '/tools/generate-uuid');
    },

    saveFcmToken(token, callback) {
        //-- Ignore if not authenticated
        var accessToken = localStorage.getItem(KEY_ACCESS_TOKEN);
        if (!accessToken) {
            return;
        }

        this._ajax_send({fcm_token: token}, {
            type: 'POST',
            success: (response) => {
                callback(response);
            },
            error: (response) => {
                this.noticeMessage('Failed to save FCM token: ' + response.message);
            }
        }, 'Sending FCM token...', this.apiBaseUrl + '/my/fcm-token');
    },

    pushNotification(target, callback) {
        var newElmt = $('<div class="list_container"><i class="fa fa-circle-notch fa-spin"></i> Sending notification...</div>');
        this._ajax_send({
            target: target
        }, {
            type: 'POST',
            beforeSend: () => {
                this.addBubble({dom: newElmt});
            },
            success: (response) => {
                $(newElmt).html('<div class="text-success"><i class="fa fa-check"></i> Notification sent successfully!</div>');
                $(this.CHATBOX).prop({ scrollTop: $(this.CHATBOX).prop('scrollHeight') });
                callback(response.data.uuid);
            },
            error: (response) => {
                $(newElmt).html('<div class="text-danger"><i class="fa fa-times"></i> Error: '+response.message+'</div>');
            }
        }, 'Sending notification...', this.apiBaseUrl + '/pushnotif');
    }
};
